<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="4">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="10">
                <v-text-field
                  label="Surveyor Type"
                  :maxlength="max_num"
                  :rules="[rules.specialCharecter]"
                  v-model="surveyTypeText"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-btn
                  class="mt-2 elevation-0"
                  fab
                  small
                  color="primary"
                  :loading="loadingSurveyor"
                  :disable="loadingSurveyor"
                  @click="createNewTypeOfSurveyor()"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-list dense v-if="surveyorTypes.length==0 || surveyorTypes =='No data found'">
              <v-list-item>
                <v-list-item-content>No Data Available</v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list dense>
              <v-list-item v-for="(item, i) in surveyorTypes" :key="i">
                <!-- <v-list-item-icon>
                  <v-icon small>lens</v-icon>
                </v-list-item-icon>-->
                <v-list-item-content>
                  <v-list-item-title v-text="item.surveyortype_name"></v-list-item-title>
                </v-list-item-content>
                <v-tooltip bottom v-if="item.candelete==1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-btn icon color="secondary">
                        <v-icon @click="deleteBusiness(item,'Surveyor')">delete_forever</v-icon>
                      </v-btn>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </v-list-item>
            </v-list>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="10">
                <v-text-field
                  label="Department"
                  :maxlength="max_num"
                  :rules="[rules.specialCharecter]"
                  v-model="departmentText"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-btn
                  class="mt-2 elevation-0"
                  fab
                  small
                  color="primary"
                  :loading="loadingDepartment"
                  :disable="loadingDepartment"
                  @click="insertNewDepartment()"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-list dense v-if="departmentList.length==0 || departmentList=='Failed'">
              <v-list-item>
                <v-list-item-content>No Data Available</v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list dense>
              <v-list-item v-for="(item, i) in departmentList" :key="i">
                <!-- <v-list-item-icon>
                  <v-icon small>lens</v-icon>
                </v-list-item-icon>-->
                <v-list-item-content>
                  <v-list-item-title v-text="item.departmentname"></v-list-item-title>
                </v-list-item-content>
                <v-tooltip bottom v-if="item.candelete==1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-btn icon color="secondary">
                        <v-icon @click="deleteBusiness(item,'Department')">delete_forever</v-icon>
                      </v-btn>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </v-list-item>
            </v-list>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="10">
                <v-text-field
                  label="Causes"
                  :maxlength="max_num"
                  :rules="[rules.specialCharecter]"
                  v-model="causeOflossText"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-btn
                  class="mt-2 elevation-0"
                  fab
                  small
                  color="primary"
                  :loading="loadingCause"
                  :disable="loadingCause"
                  @click="insertNewCauseOfloss()"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-list dense v-if="causeofLossById.length==0 || causeofLossById=='No data found'">
              <v-list-item>
                <v-list-item-content>No Data Available</v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list dense>
              <v-list-item v-for="(item, i) in causeofLossById" :key="i">
                <!-- <v-list-item-icon icon="i">
                  <v-icon small>lens</v-icon>
                </v-list-item-icon>-->
                <v-list-item-content>
                  <v-list-item-title v-text="item.cause_ofloss_name"></v-list-item-title>
                </v-list-item-content>
                <v-tooltip bottom v-if="item.candelete==1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-btn icon color="secondary">
                        <v-icon @click="deleteBusiness(item,'Causes')">delete_forever</v-icon>
                      </v-btn>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </v-list-item>
            </v-list>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="alertPositive"
      color="secondary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
    <v-snackbar
      v-model="alertNegetive"
      color="primary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      rules: {
        specialCharecter: value => {
          const pattern = /[^-\s][A-Za-z0-9 ]+$/;
          return pattern.test(value) || "Special Characters Not Allowed";
        }
      },
      surveyTypeText: "",
      departmentText: "",
      causeOflossText: "",
      loadingSurveyor: false,
      loadingDepartment: false,
      loadingCause: false,
      max_num: 30,
      causeofLossById: [],
      surveyorTypes: "",
      departmentList: "",
      timeout: 2300,
      alertNegetive: false,
      alertPositive: false,
      text: ""
    };
  },
  created() {
    this.getAllCauseofLoss();
    this.getAllSurveyorTypes();
    this.getAllDepartments();
  },
  methods: {
    async deleteBusiness(item, type) {
      if (type == "Department") {
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "DeleteDepartment_DepartmentDelete",
          input: {
            departmentid: item.departmentid
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          var deleteForDepartment = res.data.data.data;

          if (deleteForDepartment == "Deleted successfully") {
            this.text = "Deleted successfully";
            this.alertPositive = true;
            this.getAllDepartments();
          }
        } catch (error) {
          return error.response;
        }
      }
      if (type == "Surveyor") {
        input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "TypeOfSurveyor_deleteTypeOfSurveyor",
          input: {
            surveyortypeid: item.surveyortype_id
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          var deleteForSurveyor = res.data.data.data;

          if (deleteForSurveyor == "Deleted successfully") {
            this.text = "Deleted successfully";
            this.alertPositive = true;
            this.getAllSurveyorTypes();
          }
        } catch (error) {
          return error.response;
        }
      }
      if (type == "Causes") {
        input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "CauseofLoss_deleteCauseOfLoss",
          input: {
            causeoflossid: item.cause_ofloss_id
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          var deleteForCause_ofloss_id = res.data.data.data;

          if (deleteForCause_ofloss_id == "Deleted successfully") {
            this.text = "Deleted successfully";
            this.alertPositive = true;
            this.getAllCauseofLoss();
          }
        } catch (error) {
          return error.response;
        }
      }
    },
    async getAllDepartments() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "AllDepartments_getAllDepartments",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.departmentList = res.data.data.data;
      } catch (error) {
        return error.response;
      }
    },
    async getAllSurveyorTypes() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "TypeOfSurveyors_getAllSurveyorTypes",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.surveyorTypes = res.data.data.data;
      } catch (error) {
        return error.response;
      }
    },
    async getAllCauseofLoss() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "CauseOfLoss_getAllCauseofLoss",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.causeofLossById = res.data.data.data;
      } catch (error) {
        return error.response;
      }
    },
    async insertNewCauseOfloss() {
      this.loadingCause = true;
      console.log(this.causeOflossText);
      if (this.causeOflossText == "" || this.causeOflossText == null) {
        this.text = "Please Add Cause Of loss";
        this.alertNegetive = true;
        this.loadingCause = false;
      } else if (
        this.rules.specialCharecter(this.causeOflossText) ==
        "Special Characters Not Allowed"
      ) {
        this.text = "Special Characters Not Allowed";
        this.alertNegetive = true;
        this.loadingCause = false;
      } else {
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "CauseOfloss_InsertNewCauseOfloss",
          input: {
            title: this.causeOflossText,
            orgid: this.$store.getters.get_orgId
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          var CauseOfloss = res.data.data.data;
          if (CauseOfloss == "Cause of loss already exists") {
            this.text = "Cause Of Loss Already Exists";
            this.alertNegetive = true;
          } else if (CauseOfloss == "1") {
            this.getAllCauseofLoss();
            this.text = "Added Successfully";
            this.alertPositive = true;
            this.causeOflossText = "";
          } else {
            this.text = "Error";
            this.alertNegetive = true;
          }
          this.causeOflossText = null;
        } catch (error) {
          return error.response;
        }
        this.loadingCause = false;
      }
    },
    async insertNewDepartment() {
      this.loadingDepartment = true;
      if (this.departmentText == "" || this.departmentText == null) {
        this.text = "Please Add Department";
        this.alertNegetive = true;
        this.loadingDepartment = false;
      } else if (
        this.rules.specialCharecter(this.departmentText) ==
        "Special Characters Not Allowed"
      ) {
        this.text = "Special Characters Not Allowed";
        this.alertNegetive = true;
        this.loadingDepartment = false;
      } else {
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "Department_insertNewDepartment",
          input: {
            name: this.departmentText,
            orgid: this.$store.getters.get_orgId
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });

          if (res.data.data.data == "Department name already exists") {
            this.text = "Department name already exists";
            this.alertNegetive = true;
          } else if (res.data.data.data == "Department added successfully") {
            this.getAllDepartments();
            this.text = "Department Added successfully";
            this.alertPositive = true;
          } else {
            this.text = "Error";
            this.alertNegetive = true;
          }
          this.departmentText = null;
        } catch (error) {
          return error.response;
        }
        this.loadingDepartment = false;
      }
    },
    async createNewTypeOfSurveyor() {
      this.loadingSurveyor = true;
      if (this.surveyTypeText == "" || this.surveyTypeText == null) {
        this.text = "Please Add Surveyor Type";
        this.alertNegetive = true;
        this.loadingSurveyor = false;
      } else if (
        this.rules.specialCharecter(this.surveyTypeText) ==
        "Special Characters Not Allowed"
      ) {
        this.text = "Special Characters Not Allowed";
        this.alertNegetive = true;
        this.loadingSurveyor = false;
      } else {
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "TypeOfSurveyor_createNewTypeOfSurveyor",
          input: {
            typename: this.surveyTypeText,
            orgid: this.$store.getters.get_orgId
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          var surveyorType = res.data.data.data;
          if (surveyorType == "Surveyor type already exists") {
            this.text = "Surveyor type already exists";
            this.alertNegetive = true;
          } else {
            this.text = "Added Successfully";
            this.alertPositive = true;
            this.getAllSurveyorTypes();
          }
          this.surveyTypeText = null;
        } catch (error) {
          return error.response;
        }
        this.loadingSurveyor = false;
      }
    }
  }
};
</script>